import React from 'react'

import { PageHeader } from '@/components/headers/PageHeader'
import { formatTime } from '@/utils/helpers'

export const ActivityLogHeader = ({ activitySinceTime }) => {
  return (
    <PageHeader
      title="Activity Log"
      data-testid="activityLogHeader"
      actions={
        activitySinceTime && (
          <div data-testid="activityLogTime">
            <strong>Activity Since: </strong>
            <span>{formatTime(activitySinceTime)}</span>
          </div>
        )
      }
    />
  )
}
